import { TooltipHeader } from './TooltipHeader.js';

function getHeader(props) {
  if (props.tooltip) {
    return TooltipHeader(props);
  }
  return props.header;
}

export { getHeader };
